import { CalendarCheck, Users, Clock, Smartphone } from "lucide-react";
import { useTranslation } from "react-i18next";

export function Benefits() {
  const { t } = useTranslation(["landing"]);

  const items = [
    {
      icon: <CalendarCheck size={32} className="text-primary" />,
      title: t("landing:benefits_patient.tabs.title_1"),
      description: t("landing:benefits_patient.tabs.desc_1"),
    },
    {
      icon: <Users size={32} className="text-primary" />,
      title: t("landing:benefits_patient.tabs.title_2"),
      description: t("landing:benefits_patient.tabs.desc_2"),
    },
    {
      icon: <Clock size={32} className="text-primary" />,
      title: t("landing:benefits_patient.tabs.title_3"),
      description: t("landing:benefits_patient.tabs.desc_3"),
    },
    {
      icon: <Smartphone size={32} className="text-primary" />,
      title: t("landing:benefits_patient.tabs.title_4"),
      description: t("landing:benefits_patient.tabs.desc_4"),
    },
  ];
  

  return (
    <section id="benefits" className="bg-secondary text-primary py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center">
        <h2 className="text-3xl font-bold text-foreground">{t("landing:benefits_patient.title")}</h2>
        <p className="text-muted/80 mt-4 max-w-2xl mx-auto text-foreground">
          {t("landing:benefits_patient.sub_title")}
        </p>
        </div>

        <div className="grid md:grid-cols-4 gap-10 mt-12">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-xl p-6 shadow-sm"
            >
              <div className="mb-4">{item.icon}</div>

              <h3 className="text-xl font-semibold">{item.title}</h3>

              <p className="mt-2 text-foreground/70">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
